import { SEARCH_SPLIT_REGEX } from '~/chords/DropdownSingleSelect/constants';
import type { InternalDropdownOptions } from '~/chords/DropdownSingleSelect/types';

/**
 * Recursively update isVisible=true|false on the options array based on search terms.
 * Supports both flat and grouped (nested) option arrays.
 * @param options - The options to update (flat or grouped).
 * @param param1.searchQueryTrimmed - The trimmed search query.
 * @returns The updated options.
 */
export function updateIsVisibleSearch(
  options: InternalDropdownOptions,
  { searchQueryTrimmed }: { searchQueryTrimmed: string },
): InternalDropdownOptions {
  const searchQueryLower = searchQueryTrimmed.toLowerCase();
  const searchTerms = searchQueryLower.split(SEARCH_SPLIT_REGEX);

  return options.map((group) => {
    const internalOptionsGroup = 'options' in group ? group.options : group;
    const updatedOptionsGroup = internalOptionsGroup.map((option) => {
      const optionLabel = option.label || option.value;
      const optionLabelWords = optionLabel
        .toLowerCase()
        .split(SEARCH_SPLIT_REGEX);
      const isMatched = searchTerms.some((term) =>
        optionLabelWords.some((word) => word.startsWith(term)),
      );

      return {
        ...option,
        isVisible: isMatched,
      };
    });

    if ('options' in group) {
      return {
        ...group,
        options: updatedOptionsGroup,
      };
    }

    return updatedOptionsGroup;
  });
}
